import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BannerAdvancedRoutingModule } from './banner-advanced-routing.module';
import { BannerAdvancedComponent } from './banner-advanced.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonFileUploadModule } from 'src/app/global/common-file-upload/common-file-upload.module';
import { ImageBannerComponent } from './image-banner/image-banner.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CommonImagesModule } from '../../common-images/common-images.module';


@NgModule({
  declarations: [
    BannerAdvancedComponent,
    ImageBannerComponent
  ],
  imports: [
    CommonModule,
    BannerAdvancedRoutingModule,
    SharedModule,
    CommonFileUploadModule,
    NgxMatSelectSearchModule,
    CommonImagesModule
  ],
  exports:[
    ImageBannerComponent
  ]
})
export class BannerAdvancedModule { }
